import { Slot } from '@magicschool/spellbook/components/Slot';
import { Text } from '@magicschool/spellbook/components/Text';
import { cn } from '@magicschool/spellbook/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

export const caterpillarItemVariants = cva(
  [
    'inline-flex',
    'items-center',
    'justify-center',
    'rounded-full',
    'bg-surface-background-0',
    'aspect-square',
    'ring-surface-background-0',
    'z-0',
    'focus-within:z-[1]',
    'transition-[margin]',
    'shrink-0',
  ],
  {
    variants: {
      variant: {
        default: '',
      },
      size: {
        sm: 'size-control-h-sm min-w-control-h-sm min-h-control-h-sm ring-1',
        md: 'size-control-h-md min-w-control-h-md min-h-control-h-md ring-2',
        lg: 'size-control-h-lg min-w-control-h-lg min-h-control-h-lg ring-2',
      },
    },
  },
);

export const CaterpillarItemSlot = Slot<ComponentProps<'div'> & VariantProps<typeof caterpillarItemVariants>>({
  displayName: 'Caterpillar.Item',
  preventOverride: true,
  renderDefault: ({ className, size, ...props }) => {
    return <div data-spellbook-name="caterpillar-item" className={cn(caterpillarItemVariants({ size }), className)} {...props} />;
  },
});

export const CaterpillarAndMoreSlot = Slot<ComponentProps<'div'> & { count: number } & VariantProps<typeof caterpillarItemVariants>>({
  displayName: 'Caterpillar.AndMore',
  isRenderedByDefault: true,
  renderDefault: ({ className, count, size, ...props }) => {
    if (count <= 0) {
      return null;
    }

    return (
      <div
        data-spellbook-name="caterpillar-and-more"
        className={cn(
          caterpillarItemVariants({ size }),
          'bg-default-solid-background text-default-solid-foreground-text p-0.25',
          className,
        )}
        {...props}
      >
        <Text className="truncate" variant={size === 'md' ? 'label-1' : 'caption-1'} color="inherit">{`+${count}`}</Text>
      </div>
    );
  },
});
